import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '../common';
import { errorShape } from '../common/shapes';
import {
  Container,
  ErrorCode,
  ErrorImage,
  Message,
  TopRight,
} from './styles';
import Close from '../MiniControl/Close/Close';

export default function ErrorMessage({ error, miniPlayer }) {
  return (
    <Container>
      <ErrorImage />
      <Message>
        <Text id={error.errorMessage.message} values={error.errorMessage.values} />
      </Message>
      <TopRight miniPlayer={miniPlayer}>
        {miniPlayer && (
          <Close />
        )}
        <ErrorCode>
          Error Code:
          {error.code}
        </ErrorCode>
      </TopRight>
    </Container>
  );
}

ErrorMessage.propTypes = {
  error: errorShape.isRequired,
  miniPlayer: PropTypes.bool.isRequired,
};
